// Available list of roles. It Could be extended in the future
const ROLES_TO_AD_GROUPS_MAP = {
  back_of_house: '_BOH',
  stylist: ['_DigitalStylist_', '_DIGITAL_STYLIST'],
  stylist_manager: '_STYLIST_MANAGER_',
  store_associate: '_STORE_ASSOCIATE',
  store_manager: ['_STORE_MANAGER_', '_STORE_MANAGER'],
  store_general_manager: ['_STORE_GENERAL_MANAGER_', '_STORE_GENERAL_MANAGER'],
  client_advisor: ['_DIGITAL_ClIENT_ADVISOR', '_DIGITAL_CLIENT_ADVISOR'],
};

/**
 * Validate supplied `assignedADGroup` against supplied userRoles & brand
 *
 * @param {String} assignedADGroup
 * @param {String} userRoles
 * @param {String} brand
 * @param {String} validationType - determine the way to validate the supplied user `roles`
 *                  include - some user roles item matches to `assignedADGroup`
 *                  exclude - all user roles items don't match to `assignedADGroup`
 * @returns {boolean}
 */
export const validateADGroupAgainstUserRoles = ({ assignedADGroup, userRoles, brand, validationType = 'include' }) => {
  let isUserEligible = false;

  if (validationType === 'include') {
    isUserEligible = userRoles.some((roleItem) => {
      const adGroupPatters = ROLES_TO_AD_GROUPS_MAP[roleItem] || '';

      const validation = Array.isArray(adGroupPatters)
        ? adGroupPatters.some((pattern) => assignedADGroup.includes(pattern))
        : assignedADGroup.includes(adGroupPatters);

      if (validation && brand) {
        // search pattern for brand is `_<BRAND>_`
        return assignedADGroup.includes(`_${brand}_`);
      }

      return validation;
    });
  } else if (validationType === 'exclude') {
    isUserEligible = userRoles.every((roleItem) => {
      const adGroupPatters = ROLES_TO_AD_GROUPS_MAP[roleItem] || '';

      const validation = Array.isArray(adGroupPatters)
        ? adGroupPatters.every((pattern) => !assignedADGroup.includes(pattern))
        : !assignedADGroup.includes(adGroupPatters);

      if (validation && brand) {
        // search pattern for brand is `_<BRAND>_`
        return !assignedADGroup.includes(`_${brand}_`);
      }

      return validation;
    });
  }

  return isUserEligible;
};

export default validateADGroupAgainstUserRoles;
